export default "__VITE_ASSET__BLgO11hN__"